<div *ngIf="isPreprod && !isEmbedMode && !isSuperAdminRoute" class="demo-banner">
      {{'demo.banner.message' | translate}}
</div>
<router-outlet #outlet="outlet"></router-outlet>
<router-outlet name="modal"></router-outlet>
